module.exports = __webpack_public_path__ + "img/某企业的银行业绩评价模型.f23fcf4f.png";